module.exports={
  "Target": "DelmÃ¥l",
  "Show more": "Vis mere",
  "Share": "Del",
  "Download icon": "Hent ikon",
  "target": "delmaal",
  "ButtonText": "Se indikatorer" 
}
